export default __webpack_public_path__ + "static/pic09-5fce089cd6ecfd723f9349c593761d4d.jpg";